import React from 'react'
import { css } from 'emotion'
import { Link, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { Button, Alert } from "react-bootstrap";
import useConnectedUser from "app/universal/hook/useConnectedUser";
import DriverHeader from "app/universal/layout/DriverHeader";

const deployVer = process.env.REACT_APP_VERSION;
const curVersion = localStorage.getItem('version');

const Layout = (props) => {
    const location = useLocation();
    const {backButton, isCompanionLoading} = props;
    // Charge l'utilisateur connecté (header, rôles)
    useConnectedUser();
    return (
      !props.public ?
        <div id="outer-container">
        {curVersion === 'undefined' || curVersion === null || curVersion !== deployVer && <Alert variant="warning" className="mb-0 text-center">Nouvelle version disponible<br/><Button onClick={ () => window.location.reload()}>Mettre à jour</Button></Alert>}

          <DriverHeader
            logoutPath="/"
            left={backButton &&
              <Link to={{
                pathname: `/companion`, search: location.search
              }} className={css(style.link)}><FontAwesomeIcon icon={faArrowLeft} /></Link>
            }
          />
          <main id="page-wrap" className="pb-5">

            {isCompanionLoading && 
                <div className={css(style.loader)}>
                    <FontAwesomeIcon icon={faCircleNotch} size="4x" spin />
                </div> 
            }
            {props.children}
          </main>
        </div>
      :
        <>{props.children}</>
    )

}

const style = {
    link: {
        color: "black"
    },
    loader:{
        backgroundColor: "rgba(255,255,255,0.9)",
        zIndex: 9999,
        position: "fixed",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        transition: "300ms",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
}

export default Layout
